import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
//import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {Tooltip, TextField, FormControl, LinearProgress, TableContainer, Radio, TableHead, TableRow, Paper, DialogActions, DialogContentText} from '@mui/material';
import {Edit, FileCopy, Autorenew, AddTask, AutoAwesomeMosaic} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close'; 
import TopictestMngtSave from './TopictestMngtSave';
import TopictestInstances from './TopictestInstances';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className="btmbdrgry"><h3>{children}</h3></div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails); 
  const childRefSave = React.useRef();
  const childRefInstances = React.useRef();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [clone, setClone] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [keyword, setKeyword] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(0);
  const [filter, setFilter] = React.useState(false);
  // const [page, setPage] = React.useState(0);
	// const [rowCount, setRowCount] = React.useState(74);
  // const pageSize = 100;

  const [index, setIndex] = React.useState(-1);
  const [rows, setRows] = React.useState([]);  
  const [dataObj, setDataObj] = React.useState({});
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));

  const columns = [
    {
      field: "Select",
      headerName: "",
      width: 70,
      sortable: false,
        renderCell: (cellValues) => {
        return (
          <Radio 
          checked={cellValues.id === selectedRow}
          value={cellValues.id}
          name="radio-buttons"
          inputProps={{ 'aria-label': {cellValues} }}
          />
         )
        }
      },
    { field: 'id', headerName: 'Sr. No.', width: 40 },
    { field: 'topictestTitle', headerName: 'Test Title', width: 300, renderCell: (params) =>  (
      <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
       ), },
    { field: 'topicName', headerName: 'Topic', width: 290, renderCell: (params) =>  (
      <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
       ), },
    { field: 'totalQuestion', headerName: 'Questions', width: 70, renderCell: (params) =>  (
      <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
       ), },
    { field: 'noOfTestCreated', headerName: 'Total Tests', width: 70, renderCell: (params) =>  (
        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
        ), },                        
    { field: 'noOfTest', headerName: 'No Of Test', width: 70, renderCell: (params) =>  (
          <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
        ), }, 
    { field: 'questionTypes', headerName: 'Ques. Type', width: 120, renderCell: (params) =>  (
        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
         ), },
    { field: 'difficultyNames', headerName: 'Difficulty', width: 80, renderCell: (params) =>  (
      <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
      ), },
    { field: 'gradeName', headerName: 'Grade', width: 70, renderCell: (params) =>  (
      <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
      ), },
    
    ];
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    setSaveLoading(false);
    setIndex(-1);
    if(open && props.dataObj && props.dataObj.autoId && userObj && userObj.loginId){	
      getApiData();    
    }
	}, [open,props.dataObj,userObj,filter]);

	async function getApiData(){

      let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/topictest-management?templateId="+props.dataObj.autoId+"&keyword="+keyword, axiosHeader) 
			   .then(response => {
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.obj.list);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}



  function add() {
    setClone(false);
    setDataObj({});
    childRefSave.current.handleClickOpen();
  }
  function edit() {
    setClone(false);
    childRefSave.current.handleClickOpen();
  }
  function doClone() {
    setClone(true);
    childRefSave.current.handleClickOpen();
  }
  function instances() {
    childRefInstances.current.handleClickOpen();
  }
  
  function deleteData(){
		if(dataObj!=null && userObj.token){
			let axiosHeader = {
					headers: {
            'Content-Type': 'multipart/mixed',
            'loginId': userObj.loginId,
					  'token': userObj.token,
					  'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
      data.append('templateId', dataObj.templateId);
      
		  axios.post(env.API_URL+'/exams/delete/topictest-management', data, axiosHeader)
				.then((response) => {
          if(response.data && response.data.responseTxt==="invalidToken"){ 
            Cookies.remove('isadminloggedin');
            window.location.href='login';
          }else if(response.data && response.data.responseTxt==="success"){
            updatedList();
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Topic test has been deleted.");
          }else{
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Topic test could not be deleted.");			
            return false;
          }	
			})
		}				
	}

  function generateTest(opt){
		if(dataObj!=null && userObj.token){
			let axiosHeader = {
					headers: {
            'Content-Type': 'multipart/mixed',
            'loginId': userObj.loginId,
					  'token': userObj.token,
					  'device': 'web'
				}
			}; 

      setSaveLoading(true);
      
		  const data = new FormData();
		  data.append('id', dataObj.autoId);
      data.append('templateId', dataObj.templateId);
      data.append('flag', opt);
      
		  axios.post(env.API_URL+'/exams/create/topictest-instances', data, axiosHeader)
				.then((response) => {
          setSaveLoading(false);
          if(response.data && response.data.responseTxt==="invalidToken"){ 
            Cookies.remove('isadminloggedin');
            window.location.href='login';
          }else if(response.data && response.data.responseTxt==="success"){
            if(opt===0){	
              updatedList();    
            }
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Topic test has been created.");
          }else{
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Topic test could not be created.");			
            return false;
          }	
			})
		}				
	}

  function updatedList() {
    if(props.dataObj && props.dataObj.autoId && userObj && userObj.loginId){
      setDataObj({});
      setSelectedRow(0);	
      getApiData();    
    }
  }

  function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

  function search(){
		setFilter(!filter);
		setSelectedRow(0);
		setDataObj({});
	}

  function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}
  
  return (
    <>
      <Dialog fullScreen style={{margin:20}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{props.dataObj.templateTitle}: Topic Test</DialogTitle>
          <DialogContent >
          {pageLoading?<LinearProgress />:null}
          <Box mt={2}>
          <Grid container  >
            <Grid item md={12} xs={12} >
              <div style={{marginBottom:10}}>
                  <FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>
                  <Button onClick={() => {search()}} style={{textTransform:'none',maxHeight:25,marginRight:10}} color="secondary" size="small" variant="contained" >Search</Button>
                  {saveLoading?<CircularProgress color="primary" size={20} />:<>
                    <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Create</Button>
                    {selectedRow>0?<>
                      <Button onClick={() => {doClone()}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Clone</Button>
                      <Button onClick={() => {edit()}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Edit</Button>
                      <Button onClick={() => {setDeleteDialogShow(true)}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Delete</Button>
                      <Button onClick={() => {generateTest(1)}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Delete & Re-Generate Ques.</Button>
                      <Button onClick={() => {generateTest(0)}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Generate New Tests</Button>
                      {dataObj && dataObj.noOfTestCreated && dataObj.noOfTestCreated>0?
                        <Button onClick={() => {instances()}} style={{textTransform:'none',maxHeight:25,marginRight:10}} size="small" variant="outlined" >Tests List</Button>
                      :null}  
                    </>:null}
                  </>}
              </div>
            </Grid>
            <Grid item md={12} xs={12} >

            <div className="tblReport" style={{height: '73vh', width: '100%' }}>
                <DataGrid
                  rows={(rows || [])}
                  columns={columns}
                  pageSize={50}
                  rowHeight={40}
                  rowsPerPageOptions={[50]}
                  style={{fontSize:12}}
                  components={{
                    NoRowsOverlay: () => (
                      <Stack height="30%" alignItems="center" justifyContent="center">
                      <span style={{color:'#FF0000',fontWeight:'bold'}}>No data found!</span>
                      </Stack>
                    )}}	
                  onRowClick={itm => selectRow(itm)}	
                />
  					</div>



            </Grid>
          </Grid>  
        </Box>

        {(!rows || rows.length<1)?<div className='nrfbox' >No Topic test found</div>:null}


       </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <TopictestMngtSave clone={clone} updatedList={updatedList} dataObj={dataObj} dataObjTemp={props.dataObj} ref={childRefSave} />
        <TopictestInstances dataObj={dataObj} dataObjTemp={props.dataObj} ref={childRefInstances} />

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

        
    </>
  );

});

export default CustomizedDialogs;